<template lang="pug">
    div.hidden

        // main
        el-form-item(prop="name")
</template>

<script>

export default {
    name: 'AllInputFields',
}
</script>
